export const BASKET_EVENT_UPDATE = 'basket:update';
export const BASKET_EVENT_LOAD = 'basket:load';
export const BASKET_EVENT_SET_PRODUCT = 'basket:set_product';
export const BASKET_EVENT_ADD_PRODUCTS = 'basket:add_products';
export const BASKET_EVENT_DELETE_PRODUCTS = 'basket:delete_products';

export const BASKET_EVENT_SET_SERVICE = 'basket:set_service';
export const BASKET_EVENT_SET_SERVICES = 'basket:set_services';
export const BASKET_EVENT_UPDATE_SERVICE = 'basket:service_updated';
